"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.Router = exports.CrudMethod = void 0;
const Decorator_1 = require("./Decorator");
const meta = Symbol("router");
var CrudMethod;
(function (CrudMethod) {
    CrudMethod["create"] = "POST";
    CrudMethod["read"] = "GET";
    CrudMethod["update"] = "PUT";
    CrudMethod["delete"] = "DELETE";
})(CrudMethod = exports.CrudMethod || (exports.CrudMethod = {}));
class Router {
    static method(method) {
        return function (target, propertyKey, descriptor) {
            Decorator_1.Decorator.registerMatcher(target, propertyKey, async function Router_method(ctx) {
                return method === ctx.method;
            });
        };
    }
    static path(path) {
        return function (target, propertyKey, descriptor) {
            Decorator_1.Decorator.registerMatcher(target, propertyKey, async function Router_path(ctx) {
                let match = ctx.path.match(path);
                if (match !== null) {
                    ctx.pathParams = match.groups;
                    return true;
                }
                else {
                    return false;
                }
            });
        };
    }
}
exports.Router = Router;
//# sourceMappingURL=Router.js.map